(() => {
  const root = document.querySelector('[data-tac-diwali]');
  if (!root || root.dataset.initialized === 'true' || /^\/(cart|checkout|checkouts|account)(\/|$)/.test(location.pathname)) return;
  root.dataset.initialized = 'true';
  const dialog = root.querySelector('dialog');
  const preview = root.dataset.preview === 'true';
  const start = Date.parse(root.dataset.start);
  const end = Date.parse(root.dataset.end);
  const storageKey = 'tac.diwali26.drizzle.popup.v2.seen';
  let opener;
  let timer;
  const active = () => preview || Date.now() >= start && Date.now() < end;
  const close = () => {
    if (dialog.open) dialog.close();
  };
  const expire = () => {
    if (active()) return false;
    close();
    clearTimeout(timer);
    dialogObserver.disconnect();
    root.remove();
    return true;
  };
  const anotherDialogOpen = () => Array.from(document.querySelectorAll('dialog[open]')).some(other => other !== dialog);
  const dialogObserver = new MutationObserver(() => {
    if (dialog.open && anotherDialogOpen()) close();
  });
  dialogObserver.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['open'] });
  if (expire()) return;
const warmImages = () => { try { if (preview || !localStorage.getItem(storageKey)) dialog.querySelectorAll('img[loading="lazy"]').forEach(img => { img.loading = 'eager'; }); } catch (e) {} }; if (document.readyState === 'complete') setTimeout(warmImages, 1500); else window.addEventListener('load', () => setTimeout(warmImages, 1500), { once: true });
  if (!preview) {
    timer = setTimeout(expire, Math.min(Math.max(1, end - Date.now()), 2147483647));
    document.addEventListener('visibilitychange', expire);
    window.addEventListener('pageshow', expire);
  }
  root.querySelector('[data-diwali-close]').addEventListener('click', close);
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
  });
  dialog.addEventListener('close', () => {
    if (!anotherDialogOpen() && opener?.isConnected) opener.focus({ preventScroll: true });
  });
  const show = () => {
    if (document.hidden || !active() || dialog.open || document.querySelector('dialog[open]') || document.body.classList.contains('overflow-hidden')) return;
    try {
      if (!preview && localStorage.getItem(storageKey)) return;
    } catch {}
    if (typeof dialog.showModal !== 'function') return;
    opener = document.activeElement;
    dialog.showModal();
    try { if (!preview) localStorage.setItem(storageKey, '1'); } catch {}
  };
  let interactionQueued = false;
  const onInteraction = () => {
    if (interactionQueued) return;
    interactionQueued = true;
    window.setTimeout(show, 4000);
    window.removeEventListener('pointerdown', onInteraction);
    window.removeEventListener('keydown', onInteraction);
    window.removeEventListener('scroll', onInteraction);
  };
  if (preview) show();
  else {
    window.addEventListener('pointerdown', onInteraction, { passive: true });
    window.addEventListener('keydown', onInteraction);
    window.addEventListener('scroll', onInteraction, { passive: true });
  }
})();

